import { Type } from '@angular/core';

import { TellentAddMemberDialogWrapComponent } from './wrappers/add-member-dialog/add-member-dialog.component';
import { TellentAppShellWrapComponent } from './wrappers/app-shell/app-shell.component';
import { TellentAppShellTopbarButtonWrapComponent } from './wrappers/app-shell-topbar-button-wrap/app-shell-topbar-button-wrap.component';
import { TellentCompanyVerificationDialogWrapComponent } from './wrappers/company-verification-dialog/company-verification-dialog.component';
import { TellentConfirmPositionChangeDialogWrapComponent } from './wrappers/confirm-position-change-dialog/confirm-position-change-dialog-wrap.component';
import { TellentCurrentUserProfileDialogWrapComponent } from './wrappers/current-user-profile-dialog/current-user-profile-dialog-wrap.component';
import { EditMemberDialogWrapComponent } from './wrappers/edit-member-dialog/edit-member-dialog.component';
import { TellentFeatureDiscoveryDialogWrapComponent } from './wrappers/feature-discovery-dialog/feature-discovery-dialog.component';
import { TellentGettingStartedDrawerWrapComponent } from './wrappers/getting-started-drawer/getting-started-drawer.component';
import { TellentGettingStartedTriggerWrapComponent } from './wrappers/getting-started-trigger/getting-started-trigger.component';
import { TellentHelpDropdownWrapComponent } from './wrappers/help-dropdown/help-dropdown-wrap.component';
import { TellentPositionDetailsDialogWrapComponent } from './wrappers/position-details-dialog/position-details-dialog-wrap.component';
import { TellentPositionHistoryDialogWrapComponent } from './wrappers/position-history-dialog/position-history-dialog-wrap.component';
import { TellentProfileDropdownWrapComponent } from './wrappers/profile-dropdown/profile-dropdown-wrap.component';
import { TellentReportsShellComponent } from './wrappers/reports-shell/reports-shell.component';
import { TellentRouterOutlet } from './wrappers/router-outlet/router-outlet.component';
import { TellentSampleDataBannerInfoWrapComponent } from './wrappers/sample-data-banner-info/sample-data-banner-info-wrap.component';
import { TellentSubscriptionBannerWrapComponent } from './wrappers/subscription-banner/subscription-banner-wrap.component';
import { TellentAssistantMobileWrapComponent } from './wrappers/tellent-assistant-mobile/tellent-assistant-mobile.component';
import { TellentAssistantMobileTriggerWrapComponent } from './wrappers/tellent-assistant-mobile-trigger/tellent-assistant-mobile-trigger.component';
import { TellentUnassignPositionDialogWrapComponent } from './wrappers/unassign-position-dialog/unassign-position-dialog-wrap.component';

export const TellentClientComponents: Array<Type<any>> = [
  EditMemberDialogWrapComponent,
  TellentAppShellWrapComponent,
  TellentAddMemberDialogWrapComponent,
  TellentCompanyVerificationDialogWrapComponent,
  TellentCurrentUserProfileDialogWrapComponent,
  TellentProfileDropdownWrapComponent,
  TellentFeatureDiscoveryDialogWrapComponent,
  TellentHelpDropdownWrapComponent,
  TellentReportsShellComponent,
  TellentRouterOutlet,
  TellentAppShellTopbarButtonWrapComponent,
  TellentSampleDataBannerInfoWrapComponent,
  TellentSubscriptionBannerWrapComponent,
  TellentGettingStartedDrawerWrapComponent,
  TellentGettingStartedTriggerWrapComponent,
  TellentPositionDetailsDialogWrapComponent,
  TellentPositionHistoryDialogWrapComponent,
  TellentConfirmPositionChangeDialogWrapComponent,
  TellentUnassignPositionDialogWrapComponent,
  TellentAssistantMobileTriggerWrapComponent,
  TellentAssistantMobileWrapComponent,
];
